import type { Fare } from '@/src/types/itinerary'
import { useMemo } from 'react'

/**
 * Hook for managing fare and fare family selection logic
 * Determines which fare is selected based on faresList and fareFamilyFares
 */
const useFareSelection = (faresList: Fare[][] = [], fareFamilyFares: Fare[] = []) => {
    const selectedFare = useMemo(() => {
        let fare: Fare = {} as Fare
        const fareArray = faresList?.[0] || []
        fare = fareArray?.find((fare: Fare) => fare.selected) || fareArray?.[0]
        return fare
    }, [faresList])

    const selectedFareFamily = useMemo(() => {
        let fare: Fare = {} as Fare
        fare = fareFamilyFares?.find((fare: Fare) => fare.selected) || fareFamilyFares?.[0] || ({} as Fare)
        return fare
    }, [fareFamilyFares])

    return {
        selectedFare,
        selectedFareFamily
    }
}

export default useFareSelection
